__turbopack_export_value__({
  "status": "StatusOpen-module-scss-module__FBAe9G__status",
  "status_closed": "StatusOpen-module-scss-module__FBAe9G__status_closed",
});
